export function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([а-яёa-z\-0-9]+\.)+[а-яёa-z]{2,}))$/i;
    return re.test(email);
}

export function parseBool(v) {
    if(typeof v == 'string' && v.toLowerCase) v = v.toLowerCase();
    return v && v !== '0' && v !== 'false' && v !== 'off' && v !== 'no' && v !== 'null';
}

export function parse_url(url) {
    const a = document.createElement('a');
    a.href = url;
    return {
        protocol: a.protocol.replace(':', ''),
        host: a.hostname,
        port: a.port,
        query: a.search,
        params: (function(){
            let ret = {},
                seg = a.search.replace(/^\?/,'').split('&'),
                len = seg.length, i = 0, s;
            for (;i<len;i++) {
                if (!seg[i]) { continue; }
                s = seg[i].split('=');
                ret[s[0]] = s[1];
            }
            return ret;
        })(),
        file: (a.pathname.match(/\/([^\/?#]+)$/i) || [,''])[1],
        hash: a.hash.replace('#',''),
        path: a.pathname.replace(/^([^\/])/,'/$1'),
        relative: (a.href.match(/tp:\/\/[^\/]+(.+)/) || [,''])[1],
        segments: a.pathname.replace(/^\//,'').split('/'),
        getParameter: function(name, defaultValue) {
            name = name.toLowerCase();
            const params = {};
            Object.keys(this.params).forEach(function(key) {
                params[key.toLowerCase()] = this.params[key];
            }.bind(this));
            return typeof params[name] !== 'undefined' ? params[name] : defaultValue;
        }
    };
}

export function intval(value) {
    return isNaN(value) ? 0 : parseInt(value);
}

export function in_array(value, arr) {
    return arr instanceof Array && arr.indexOf && arr.indexOf(value) >= 0;
}

export const rangeLimit = (value, min, max) => {
    if (value < min) return min;
    if (value > max) return max;
    return value;
}
